// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"4427a3a5","160":"af6023ca","208":"48991d85","293":"49aee1a3","516":"ed7f28a2","519":"6c94b66b","917":"a0b298e2","946":"319c203e"}[chunkId] + ".chunk.js";
};